(() => {
  const media = window.matchMedia('(max-width: 767px)');
  const init = (root = document) => {
    root.querySelectorAll('[data-gl2-footer-group]').forEach(group => {
      if (group.dataset.footerReady) return;
      group.dataset.footerReady = 'true';
      const summary = group.querySelector('summary');
      if (!summary) return;
      const update = () => {
        if (!media.matches || !group.contains(document.activeElement)) group.open = !media.matches;
        summary.tabIndex = media.matches ? 0 : -1;
        summary.setAttribute('aria-expanded', String(group.open));
      };
      summary.addEventListener('click', event => { if (!media.matches) event.preventDefault(); });
      group.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(group.open)));
      media.addEventListener('change', update);
      update();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

/* Keep Boost's own button and click handler; reserve space at the mobile footer. */
(() => {
  if (window.gl2FooterBackTopReady) return;
  window.gl2FooterBackTopReady = true;
  const mobile = window.matchMedia('(max-width: 767px)');
  const selector = '.boost-sd__scroll-to-top';
  let footer, dock, buttons = [], frame = 0;
  const update = () => {
    frame = 0;
    if (!footer || !dock) return;
    const active = mobile.matches && buttons.length > 0;
    dock.hidden = !active;
    const docked = active && footer.getBoundingClientRect().top < window.innerHeight;
    if (docked) {
      const rect = dock.getBoundingClientRect();
      document.documentElement.style.setProperty('--gl2-back-top-y', `${rect.top + 8}px`);
      document.documentElement.style.setProperty('--gl2-back-top-right', `${document.documentElement.clientWidth - rect.right}px`);
    }
    buttons.forEach(button => button.classList.toggle('gl2-back-top-docked', docked));
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const resize = new ResizeObserver(schedule);
  const sync = () => {
    buttons = [...document.querySelectorAll(selector)];
    const nextFooter = document.querySelector('footer.gl2-footer');
    if (nextFooter !== footer) {
      if (footer) resize.unobserve(footer);
      if (dock) dock.remove();
      footer = nextFooter;
      dock = null;
      if (footer) resize.observe(footer);
    }
    if (footer && buttons.length && !dock) {
      dock = document.createElement('span');
      dock.className = 'gl2-back-top-dock';
      dock.setAttribute('aria-hidden', 'true');
      dock.hidden = true;
      footer.append(dock);
    }
    schedule();
  };
  const relevant = node => node.nodeType === 1 &&
    (node.matches(`${selector}, footer.gl2-footer`) || node.querySelector(`${selector}, footer.gl2-footer`));
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(relevant))) sync();
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  sync();
})();
